// extracted by mini-css-extract-plugin
export default {"sortablePlaceholder":"SortableItemPlaceholder_sortablePlaceholder__JAa0s"};